import * as React from 'react';
import { FormGroup } from '../../form/FormGroup';
import { FormInput } from '../../form/FormInput';
import { FormComponentProps, KeyValue } from '../../form/Form';
import { FormTransferContainer } from '../../form/FormTransferContainer';
import { Validators } from '../../form/Validators';
import { FeatureToggleService } from '../../../service/FeatureToggleService';
import { SelectInput } from "../../form/SelectInput";
import { PayoutStructure } from '../../../../generated/protocol';

const CONFIGURATION_MODEL: string = 'configuration';
const SATELLITE_TOURNAMENT_MODEL: string = 'satelliteConfiguration';

interface BountyTournamentProps extends FormComponentProps {
    hasRebuy : boolean;
    payoutStructures: PayoutStructure[];
}

export class BountyTournamentPanel extends React.Component<BountyTournamentProps, {}> {
    
    getConfigurationModel() {
        return this.props.fieldSet.getModelValue(CONFIGURATION_MODEL);
    }

    getSatelliteModel() {
        return this.props.fieldSet.getModelValue(SATELLITE_TOURNAMENT_MODEL);
    }

    resetBountyFields(){
        this.props.fieldSet.updateModels([
            new KeyValue<any>('configuration.bountyFee', 0 , false, {errorName: null, pristine: false}),
            new KeyValue<any>('configuration.progressivePercentage', 0 , false, {errorName: null, pristine: false}),
        ]);
    };

    resetMysteryBountyFields() {
        this.props.fieldSet.updateModels([
            new KeyValue<any>('configuration.mysteryBountyFee', 0 , false, {errorName: null, pristine: false}),
            new KeyValue<any>('configuration.mysteryBountyGuaranteedPrizePool', 0 , false, {errorName: null, pristine: false}),
        ]);
    }

    resetProgressivePercentage(){
        this.props.fieldSet.updateModel('configuration.progressivePercentage', 0 , false, {errorName: null, pristine: false});             
    };

    render() {
        const configuration = this.getConfigurationModel();
        const satelliteConfiguration = this.getSatelliteModel();

        const isSatelliteTournament = satelliteConfiguration && satelliteConfiguration.isSatellite;
        const hasBounty = configuration.hasBounty;
        const bountyFee = configuration.bountyFee;
        const progressivePercentage = configuration.progressivePercentage;
        const hasMysteryBounty = configuration.hasMysteryBounty;
        const mysteryBountyFee = configuration.mysteryBountyFee;
        const mysteryBountyGuaranteedPrizePool = configuration.mysteryBountyGuaranteedPrizePool;
        const disableBountyTournaments = this.props.hasRebuy || isSatelliteTournament;

        if(hasBounty && isNaN(progressivePercentage)) this.resetProgressivePercentage();

        const bountyFieldsNotDefault = bountyFee > 0 || bountyFee  === "" || progressivePercentage > 0 || progressivePercentage === "";
        if (!hasBounty && bountyFieldsNotDefault) this.resetBountyFields();
        const mysteryBountyFieldsNotDefault = mysteryBountyFee > 0 || mysteryBountyFee === "" || mysteryBountyGuaranteedPrizePool > 0 || mysteryBountyGuaranteedPrizePool === "";
        if (!hasMysteryBounty && mysteryBountyFieldsNotDefault) this.resetMysteryBountyFields();

        return (
            <FormTransferContainer {...this.props}>
                <div className='row target-tournament-panel'>
                    <div className='col-lg-12'>
                        <div className='ibox float-e-margins'>
                            <div className='ibox-title'>
                                <h5>Bounty Tournaments</h5>
                            </div>
                            <div className='ibox-content'>
                                <FormGroup className='form-group'>
                                    <label className='col-sm-2 control-label'>Is Bounty Tournament</label>
                                    <div className='col-sm-10'>
                                        <FormInput disabled={disableBountyTournaments || hasMysteryBounty} type='checkbox' model='configuration.hasBounty' />
                                    </div>
                                </FormGroup>
                                {hasBounty && <div>
                                    <div className='hr-line-dashed'></div>
                                    <FormGroup className='form-group'>
                                        <label className='col-sm-2 control-label'>Bounty Fee (per player)</label>
                                        <div className='col-sm-10'>
                                            <FormInput type='float' model='configuration.bountyFee'
                                                       className='form-control' validators={[Validators.required(), Validators.min(0.01), Validators.maxDecimalPlaces(2)]}/>
                                            <span className='help-block m-b-none'>Must not be: blank; 0; alpha-numeric; special characters; negative values; more than 2 decimal places;</span>
                                        </div>
                                    </FormGroup>
                                </div>}
                                {hasBounty && <div>
                                    <div className='hr-line-dashed'></div>
                                    <FormGroup className='form-group'>
                                        <label className='col-sm-2 control-label'>Progressive Percentage (Note: Field must be filled - 0 = non progressive bounty)</label>
                                        <div className='col-sm-10'>
                                            <FormInput type='float' model='configuration.progressivePercentage'
                                                       className='form-control' validators={[Validators.required(), Validators.range(0, 100), Validators.integer()]}/>
                                            <span className='help-block m-b-none'>(Percentage of the bounty added to the players current bounty). Must not be: blank; alpha-numeric; special characters; negative values; greater than 100; decimal places; </span>
                                        </div>
                                    </FormGroup>
                                </div>}
                                {FeatureToggleService.mysteryBountiesFeatureFlag.isEnabled && <div>
                                    <div className='hr-line-dashed'></div>
                                    <FormGroup className='form-group'>
                                        <label className='col-sm-2 control-label'>Is Mystery Bounty Tournament</label>
                                        <div className='col-sm-10'>
                                            <FormInput type='checkbox' model='configuration.hasMysteryBounty' disabled={disableBountyTournaments || hasBounty}/>
                                        </div>
                                    </FormGroup>
                                    {hasMysteryBounty && <div>
                                        <div className='hr-line-dashed'></div>
                                        <FormGroup className='form-group'>
                                            <label className='col-sm-2 control-label'>Mystery Bounty Fee</label>
                                            <div className='col-sm-10'>
                                                <FormInput type='float' model='configuration.mysteryBountyFee'
                                                           className='form-control'
                                                           validators={[Validators.required(), Validators.min(0.00), Validators.maxDecimalPlaces(2)]}/>
                                                <span className='help-block m-b-none'>Must not be: blank; alpha-numeric; special characters; negative values; more than 2 decimal places;</span>
                                            </div>
                                        </FormGroup>
                                        <div className='hr-line-dashed'></div>
                                        <FormGroup className='form-group'>
                                            <label className='col-sm-2 control-label'>Mystery Bounty Prize Structure</label>
                                            <div className='col-sm-10'>
                                                <SelectInput
                                                    className='form-control m-b'
                                                    model='configuration.mysteryBountyPrizeStructureId'
                                                    values={this.props.payoutStructures}
                                                    displayValue={a => a.name}
                                                    optionModelValue={a => a.id}
                                                />
                                            </div>
                                        </FormGroup>
                                        <FormGroup className='form-group'>
                                            <label className='col-sm-2 control-label'>Mystery Bounty Guaranteed Prize Pool</label>
                                                { mysteryBountyFee === 0 ?
                                                    <div className='col-sm-10'>
                                                        <FormInput type='float'
                                                           model='configuration.mysteryBountyGuaranteedPrizePool'
                                                           validators={[Validators.required(), Validators.min(0.01), Validators.maxDecimalPlaces(2)]}
                                                           className='form-control'/>
                                                        <span className='help-block m-b-none'>Must be set when the Mystery Bounty Fee is 0</span>
                                                    </div>
                                                    :
                                                    <div className='col-sm-10'>
                                                        <FormInput type='float'
                                                            model='configuration.mysteryBountyGuaranteedPrizePool'
                                                            validators={[Validators.required(), Validators.min(0.00), Validators.maxDecimalPlaces(2)]}
                                                            className='form-control'/>
                                                    </div>
                                                }
                                        </FormGroup>
                                    </div>}
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </FormTransferContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/poker/tournament/BountyTournamentPanel.tsx